module.exports = __webpack_public_path__ + "img/icon-copy.eba110f8.svg";